module.exports = __webpack_public_path__ + "img/60.05e3dee2.jpg";